// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"d5529ed4","3":"25e7b17c","97":"02ad0510","100":"e60aabbc","149":"5447b689","190":"cf85dee7","206":"c6f7a447","436":"ba22aeb6","627":"87d072a8","881":"f64b218a"}[chunkId] + ".chunk.css";
};